const ssrStub = {
  identify: () => {},
  track: () => {},
  ready: () => {},
};

const getAnalytics = () => (typeof window === "undefined" ? ssrStub : window.analytics);

export { getAnalytics };
